import { useState } from "react";
import {
  Box,
  Typography,
  Stack,
  TextField,
  Button,
  Chip,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Switch,
  FormControlLabel,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import ImportarExcelSimple from "../shared/ImportarExcelSimple";

const HEADERS_IMPORT = ["nombre", "precio", "esRecurrente", "diasVigencia", "diasRecordatorio"];
const esAfirmativo = (valor) => /^(si|sí|true|1|yes|s)$/i.test(String(valor || "").trim());

export default function ConfigProductos({ store }) {
  const [nuevoProducto, setNuevoProducto] = useState({ nombre: "", precio: "", esRecurrente: false, diasVigencia: "", diasRecordatorio: "" });

  const handleAgregar = () => {
    if (!nuevoProducto.nombre.trim()) return;
    const prod = {
      nombre: nuevoProducto.nombre.trim(),
      precio: parseFloat(nuevoProducto.precio) || 0,
    };
    if (nuevoProducto.esRecurrente) {
      prod.esRecurrente = true;
      prod.diasVigencia = parseInt(nuevoProducto.diasVigencia) || 30;
      prod.diasRecordatorio = parseInt(nuevoProducto.diasRecordatorio) || 7;
    }
    store.agregarProducto(prod);
    setNuevoProducto({ nombre: "", precio: "", esRecurrente: false, diasVigencia: "", diasRecordatorio: "" });
  };

  return (
    <Box>
      <Stack direction="row" spacing={1} mb={1}>
        <TextField
          label="Nombre"
          value={nuevoProducto.nombre}
          onChange={(e) => setNuevoProducto({ ...nuevoProducto, nombre: e.target.value })}
          size="small"
          sx={{ flex: 1 }}
        />
        <TextField
          label="Precio"
          value={nuevoProducto.precio}
          onChange={(e) => setNuevoProducto({ ...nuevoProducto, precio: e.target.value })}
          type="number"
          size="small"
          sx={{ width: 100 }}
        />
        <Button variant="outlined" size="small" onClick={handleAgregar} disabled={!nuevoProducto.nombre.trim()}>
          <AddIcon />
        </Button>
      </Stack>
      <FormControlLabel
        control={
          <Switch
            checked={nuevoProducto.esRecurrente}
            onChange={(e) => setNuevoProducto({ ...nuevoProducto, esRecurrente: e.target.checked })}
            size="small"
          />
        }
        label={<Typography variant="caption">¿Tiene vencimiento / renovación?</Typography>}
        sx={{ mb: 1 }}
      />
      {nuevoProducto.esRecurrente && (
        <Stack direction="row" spacing={1} mb={1}>
          <TextField
            label="Vigencia (días)"
            value={nuevoProducto.diasVigencia}
            onChange={(e) => setNuevoProducto({ ...nuevoProducto, diasVigencia: e.target.value })}
            type="number"
            size="small"
            sx={{ width: 120 }}
            placeholder="30"
          />
          <TextField
            label="Recordar antes (días)"
            value={nuevoProducto.diasRecordatorio}
            onChange={(e) => setNuevoProducto({ ...nuevoProducto, diasRecordatorio: e.target.value })}
            type="number"
            size="small"
            sx={{ width: 150 }}
            placeholder="7"
          />
        </Stack>
      )}
      {store.config.productos.length === 0 ? (
        <Typography variant="caption" color="text.secondary">Sin productos configurados</Typography>
      ) : (
        <List dense disablePadding>
          {store.config.productos.map((p) => (
            <ListItem key={p.id} disableGutters>
              <ListItemText
                primary={
                  <Stack direction="row" spacing={0.5} alignItems="center">
                    <span>{p.nombre}</span>
                    {p.esRecurrente && (
                      <Chip
                        icon={<AutorenewIcon sx={{ fontSize: 14 }} />}
                        label={`${p.diasVigencia || 30}d`}
                        size="small"
                        color="info"
                        variant="outlined"
                        sx={{ fontSize: 10, height: 20 }}
                      />
                    )}
                  </Stack>
                }
                secondary={`${store.config.moneda} ${p.precio}`}
              />
              <ListItemSecondaryAction>
                <IconButton
                  size="small"
                  edge="end"
                  onClick={() =>
                    store.actualizarConfig({
                      productos: store.config.productos.filter((x) => x.id !== p.id),
                    })
                  }
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
      )}
      <ImportarExcelSimple
        headers={HEADERS_IMPORT}
        filaEjemplo={["Acero", "22", "no", "", ""]}
        filename="plantilla-productos-crm.xlsx"
        titulo="Importar productos (Excel)"
        ayuda="Obligatorio: nombre. esRecurrente: si/no. Duplicados por nombre se omiten."
        columnasObligatorias={["nombre"]}
        onFilas={(filas) => store.agregarProductosMasivo(filas.map((f) => ({
          nombre: f.nombre,
          precio: f.precio,
          esRecurrente: esAfirmativo(f.esRecurrente),
          diasVigencia: f.diasVigencia,
          diasRecordatorio: f.diasRecordatorio,
        })))}
      />
    </Box>
  );
}
